<script setup>
const props = defineProps({
  modelValue: {
    required: true,
  },
  hasInstructors: {
    type: Boolean,
  },
})
const emit = defineEmits(['update:modelValue'])

const { t } = useI18n()

const options = computed(() => {
  const tabOptions = [
    {
      value: 1,
      label: t('Overview'),
      icon: 'i-far-memo-circle-info',
    },
    {
      value: 2,
      label: t('Venue'),
      icon: 'i-far-map-location',
    },
    ...(props.hasInstructors
      ? [
          {
            value: 3,
            label: t('Instructor'),
            icon: 'i-far-people-group',
          },
        ]
      : []),
  ]

  return tabOptions
})

const internalValue = ref(props.modelValue)
const activeObject = computed(() =>
  options.value?.find(option => option.value === internalValue.value),
)

watch(internalValue, (value) => {
  emit('update:modelValue', value)
})

onMounted(() => {
  internalValue.value = props.modelValue
})
</script>

<template>
  <div>
    <!-- Tabs -->
    <DSTabBar
      v-model="internalValue"
      class="bg-surface-100 lt-sm:hidden"
      :options="options"
    />
    <!-- Dropdown -->
    <DSListboxInput
      v-model="internalValue"
      class="sm:hidden"
      :options="options"
      :deselect="false"
      value-key="value"
    >
      <template #inputLabel>
        <div class="flex flex-row items-center flex-gap-2">
          <DSIcon :icon="activeObject?.icon" />
          <p>{{ activeObject?.label }}</p>
        </div>
      </template>
      <template #option="{ option }">
        <div class="flex flex-row items-center flex-gap-2 px-3 py-2">
          <DSIcon :icon="option.icon" />
          <p>{{ option.label }}</p>
        </div>
      </template>
    </DSListboxInput>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Overview": "Overview",
    "Venue": "Venue",
    "Instructor": "Instructor"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Overview": "Übersicht",
  "Venue": "Veranstaltungsort",
  "Instructor": "Trainer:in"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Overview": "Aperçu",
  "Venue": "Lieu",
  "Instructor": "Instructeur"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Overview": "Información general",
  "Venue": "Sede",
  "Instructor": "Instructor"
}
</i18n>
